import { Link } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import type { MassUpdateFlow } from "@/mocks/navigate-to-mass-update-flow";

interface FlowEntryCardProps {
  flow: MassUpdateFlow;
  icon: LucideIcon;
}

export function FlowEntryCard({ flow, icon: Icon }: FlowEntryCardProps) {
  return (
    <Card className="flex h-full flex-col">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="flex size-10 items-center justify-center rounded-md bg-primary/10 text-primary">
            <Icon className="size-5" />
          </div>
          <p className="text-xs font-semibold uppercase tracking-[0.06em] text-muted-foreground">
            {flow.kicker}
          </p>
        </div>
        <CardTitle className="text-lg">{flow.title}</CardTitle>
        <CardDescription>{flow.description}</CardDescription>
      </CardHeader>
      <CardFooter className="mt-auto">
        <Button asChild className="w-full sm:w-auto">
          <Link to={flow.href}>Open</Link>
        </Button>
      </CardFooter>
    </Card>
  );
}
